<template>
  <CModal
    :show.sync="managerViewModal"
    :centered="true"
    :title="`${user.name}  ${user.lastname} - ${user.nationalId}`"
    size="md"
    class="text-center"
  >
    <CRow>
      <CCol sm="12">
        <img :src="user.profileImageUrl" class="profile-image" />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="6">
        <div class="mb-3">نام: {{ user.name }}</div>
        <div class="mb-3">کد ملی: {{ user.nationalId }}</div>
      </CCol>
      <CCol sm="6">
        <div class="mb-3">نام خانوادگی: {{ user.lastname }}</div>
        <div class="mb-3">شماره‌ی تماس: {{ user.mobile }}</div>
      </CCol>
    </CRow>
    <template #footer>
      <CButton
        :disabled="loading"
        @click="managerEditModal = true"
        color=""
        class="gray-200 px-5"
      >
        اصلاح
      </CButton>
      <EditManagerModal
        v-model="managerEditModal"
        :user="user"
        @get-manager="getManager"
        @close-view-modal="closeViewModal"
      />
      <CButton
        :disabled="loading"
        @click="managerViewModal = false"
        color="primary"
        class="px-5"
      >
        بستن
      </CButton>
    </template>
  </CModal>
</template>

<script>
import EditManagerModal from "./EditManagerModal.vue";
export default {
  components: { EditManagerModal },
  props: {
    value: {
      type: Boolean,
    },
    user: {
      type: Object,
    },
  },
  data() {
    return {
      managerEditModal: false,
    };
  },
  computed: {
    managerViewModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getManager() {
      this.$emit("get-manager");
    },
    closeViewModal() {
      this.managerViewModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.profile-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.gray-200 {
  color: #636f83;
  background-color: #d8dbe0;
}
</style>
